const init = {
  shopperToken: null,
  products: []
};

export default function reducer(state = init, action) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/components/gifting/actions.js